<template>
  <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.013 1H1L9 10.46V17L13 19V10.46L13.9 9.405M21 1L16 6M16 1L21 6" stroke="#6782F6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>